import { Outdoor } from "./outdoor.js"

export class Neighborhood extends Outdoor {
    static info = {
        key: "neighborhood",
        name: "Decorate the neighborhood with lanterns",
        description: "Time to decorate the neighborhood with lanterns for the celebration. In this neighborhood, each string of lanterns has a pattern. Make sure each string has three shapes of lanterns.",
        logo: { x: 420, y: 520 },
        won: false
    }
    constructor(key, level, options){
        super(key, level, { ...options, holder: true, speed : 2 })
        this._gallows = {
            group: null,
            list: [
                {
                    "name": "dnl-lantern-display-top",
                    "position": {"left": 1643, "top": 671},
                },
                {
                    "name": "dnl-lantern-display-left",
                    "position": {"left": 799, "top": 1469},
                },
                {
                    "name": "dnl-lantern-display-right",
                    "position": {"left": 2716, "top": 1472},
                },
                {
                    "name": "dnl-lantern-display-bottom",
                    "position": {"left": 1884, "top": 2294},
                }
            ]
        }
        this._pickables = {
            group: null,
            list: [
                {
                    "name": "dnl-lantern-1-1",
                    "position": { "left": 572, "top": 618 },
                    "destinations": [
                        {
                            "name": "dnl-lantern-display-bottom",
                            "x": 2133,
                            "y": 2458,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-left",
                            "x": 1045,
                            "y": 1631,
                            "fullfilled" : false
                        }
                    ]
                },
                {
                    "name": "dnl-lantern-1-2",
                    "position": {"left": 1086, "top": 618},
                    "destinations": [
                        {
                            "name": "dnl-lantern-display-bottom",
                            "x": 2133,
                            "y": 2458,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-left",
                            "x": 1045,
                            "y": 1631,
                            "fullfilled" : false
                        }
                    ]
                },
                {
                    "name": "dnl-lantern-2-1",
                    "position": {"left": 442, "top": 578},
                    "destinations": [
                        {
                            "name": "dnl-lantern-display-top",
                            "x": 1761,
                            "y": 820,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-right",
                            "x": 2834,
                            "y": 1618,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-bottom",
                            "x": 1997,
                            "y": 2439,
                            "fullfilled" : false
                        },
                    ]
                },
                {
                    "name": "dnl-lantern-2-2",
                    "position": {"left": 962, "top": 578},
                    "destinations": [
                        {
                            "name": "dnl-lantern-display-top",
                            "x": 1761,
                            "y": 820,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-right",
                            "x": 2834,
                            "y": 1618,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-bottom",
                            "x": 1997,
                            "y": 2439,
                            "fullfilled" : false
                        },
                    ]
                },
                {
                    "name": "dnl-lantern-2-3",
                    "position": {"left": 1238, "top": 578},
                    "destinations": [
                        {
                            "name": "dnl-lantern-display-top",
                            "x": 1761,
                            "y": 820,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-right",
                            "x": 2834,
                            "y": 1618,
                            "fullfilled" : false
                        },
                        {
                            "name": "dnl-lantern-display-bottom",
                            "x": 1997,
                            "y": 2439,
                            "fullfilled" : false
                        },
                    ]
                },
                {
                    "name": "dnl-lantern-3",
                    "position": {"left": 311, "top": 579},
                    "destinations": [
                        {
                            "name": "dnl-lantern-display-right",
                            "x": 3134,
                            "y": 1620,
                            "fullfilled" : false
                        }
                    ]
                },
            ]
        }
        this._totalStars = null
    }
    preload(){
        super.preload()
        this._gallows.list.forEach(h => this.load.image(h.name, `assets/neighborhood/decor-hangers/${h.name}.png`))
        this._pickables.list.forEach(d => this.load.image(d.name, `assets/neighborhood/decorations/${d.name}.png`))
    }
    create(){
        super.create()
        this._gallows.group = this.physics.add.staticGroup()
        this._gallows.list.forEach(a => {
            let so = this._gallows.group.create(a.position.left, a.position.top, a.name).setOrigin(0, 0).refreshBody()
            so.setSize(so.body.width, so.body.height - 155, false)
        })
        this._pickables.group = this.physics.add.staticGroup()
        this._pickables.list.forEach(d => {
            let so = this._pickables.group.create(d.position.left, d.position.top, d.name).setOrigin(0, 0).refreshBody().setDepth(60)
            so.setSize(so.body.width, so.body.height - 155, false)
        })
        this.physics.add.collider(this.bob, [this._pickables.group, this._gallows.group])
        this.time.addEvent({ delay: 2000, callback: ()=> {if(this.board.score.text[0] !== 0) return;this.peiPeiSay("Help decorate your neighborhood. Remember to follow the patterns!")}, callbackScope: this })
        this._totalStars = this._pickables.list.length * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${this._totalStars}`)
    }
    onSpace(){
        const handleGroundDecor = () => {
            const overlaps = this._pickables.group.children.entries.filter(d => this.physics.overlapRect(d.x, d.y, d.width, d.height, true, false).length !== 0)
            if (overlaps.length !== 1) return
            this._holder.back().take(overlaps[0])
        }
        handleGroundDecor()

        const hangDecor = () => {
            if (!this._holder.holding() || this._holder.busy) return
            //Check if it can be hanged
            const overlaps = this._gallows.group.children.entries.filter(d => this.physics.overlapRect(d.x, d.y, d.width, d.height, true, false).length !== 0)
            if (overlaps.length !== 1) return
            let targetDecor = this._pickables.list.filter(d => d.name === this._holder.item.texture.key )
            let decorPosition = targetDecor[0].destinations.filter(i => i.name === overlaps[0].texture.key)
            if (!decorPosition[0]) {
                this.peiPeiSay("Oops...that doesn’t follow the pattern!")
                this.sound.play("wrong")
                return
            }
            // Hang it
            if(decorPosition[0].fullfilled) {this.peiPeiSay("Oops...that doesn’t follow the pattern!"); this.sound.play("wrong"); return}
            this._holder.drop(decorPosition[0])
            this._pickables.list.forEach(p => p.destinations.filter(i => i.x === decorPosition[0].x && i.y === decorPosition[0].y).forEach(item => item.fullfilled = true))
            let score = this.board.score.text
            this.board.score.setText(`${parseInt(score) + 5}/${this._totalStars}`)
            let remaining = this._pickables.group.countActive(true)
            this.peiPeiSay("Nice job! You earned 5 stars! Go grab another lantern!")
            this.sound.play("right")
            //Check if won
            if (remaining !== 0) return
            this.peiPeiSay("Mission Accomplished!")
            this.win(this.board.score.text)
        }
        hangDecor()
    }
}